document.addEventListener("DOMContentLoaded", () => {
  const mobileHeader = document.querySelector(".navigation__mobile-header");
  const tierContainers = document.querySelectorAll(".navigation__tier-2-container");

  // Fonction pour ajuster la position "top"
  const adjustTopPosition = (isVisible) => {
    tierContainers.forEach((container) => {
      const currentTop = parseInt(container.style.top || "0", 10);
      if (isVisible) {
        // Si le header est visible, augmenter "top" de 50px
        container.style.top = `${currentTop + 50}px`;
      } else {
        // Sinon, réduire "top" de 50px
        container.style.top = `${currentTop - 50}px`;
      }
    });
  };

  // Afficher le header et ajuster "top" lors de la sélection d'un item
  document.querySelectorAll(".navigation__children-toggle").forEach((toggle) => {
    toggle.addEventListener("click", (e) => {
      e.preventDefault();

      // Rendre visible le mobile header
      if (!mobileHeader.classList.contains("navigation__mobile-header--visible")) {
        mobileHeader.classList.add("navigation__mobile-header--visible");
        adjustTopPosition(true); // Ajuster "top" pour afficher l'espace sous le header
      }
    });
  });

  // Cacher le header et ajuster "top" lorsque l'on clique sur "Retour"
  const backButton = document.querySelector(".mobile-nav-back");
  if (backButton) {
    backButton.addEventListener("click", (e) => {
      e.preventDefault();

      if (mobileHeader.classList.contains("navigation__mobile-header--visible")) {
        mobileHeader.classList.remove("navigation__mobile-header--visible");
        adjustTopPosition(false); // Ajuster "top" pour masquer l'espace sous le header
      }
    });
  }
});